export default "__VITE_ASSET__BGmZ0USY__"